/**
 * Which clinics have a Manifold catalog.
 *
 * Used only to decide whether to show the nav entries. The backend is the
 * authority on both access and edit mode — every catalog response carries
 * `pricing_mode` and `pricing_enabled`, and the write path is gated server-side
 * regardless of what this file says.
 *
 * Every clinic is now on the multitenant Manifold: pricing is staged as draft
 * changes and shipped by publishing a release, applied through the changeset
 * API. MDExam and MDRX were the last on the single-tenant deployment and moved
 * on 2026-08-04, which retired the old direct-write editing model entirely.
 *
 * Kept in step with backend/src/config/manifoldTenants.js.
 */

/** Clinics whose pricing is managed through drafts and releases — all of them. */
export const MANIFOLD_MANAGED_CLINICS = [
  'mdexam',
  'mdexam_legacy',
  'mdrx',
  'vigore',
  'evamd',
  'revora',
  'trybalance',
  'scienceco',
  'rxbloom',
]

/** Every clinic with a Manifold catalog to show. */
export const MANIFOLD_CATALOG_CLINICS = MANIFOLD_MANAGED_CLINICS

/**
 * Every clinic that has a Manifold tenant_id, and so has payments data.
 *
 * The same list, under the name that describes what the payments screens
 * actually depend on: a tenant, not a catalog. `/ops/payments` used to be gated
 * on the Chargebee clinic list, which hid it from the seven tenants that were
 * never on Chargebee even though the dashboard route serves them fine — it
 * resolves the tenant per request and has no MDExam-specific path.
 */
export const MANIFOLD_TENANT_CLINICS = MANIFOLD_MANAGED_CLINICS

export function isManagedPricingClinic(clinicId) {
  return MANIFOLD_MANAGED_CLINICS.includes(clinicId)
}
